/* Ban-109 (TEST 12) — EZ cart drawer + Teeinblue "Edit design" in it.
   Why: after Add to Cart the customer stayed on /cart (Teeinblue's atc_action "redirect"); a gift for each person in the
   family meant going back and loading the form again. Pawfect House / Suzitee keep the customer on the page with a drawer.
   Measured 21/10 on Pawfect: the drawer was fully open ~4.0 s after the tap and its "Edit Design" target was 110×16 px;
   here the drawer opens at once with "Adding…" and the targets are ≥ 44 px.
   - Content = sections/ez-cart-drawer.liquid via the Section Rendering API (no product suggestions: anh 21/10).
   - The shell is built once at idle; opening/closing only switches classes (§ performance rules: no body overflow lock,
     one click + one keydown listener on window capture, no layout reads on click, no URL change).
   - Edit design = Teeinblue's own button (div.tee-edit-customization). Teeinblue scans for those divs on its
     "shopify-event-cart-ajax" document event, so we send it after each render. On pages without Teeinblue
     (home, collections) its shop config, saved earlier from a product/cart page, is put back and app-v1.js loaded
     only when the drawer shows a design line (tested 21/10 on the home page: 226 ms with the file cached, 62 ms run).
   - Save in Teeinblue's edit popup calls window.teeinblue.handleCustomizationEditted(): the drawer redraws in place.
   - The popup's close (× / dark area) asks "Discard your changes?" only after a real change. */
(function () {
  "use strict";
  if (window.ezCartDrawer) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var R = window.routes || {};
  var SECTION = "ez-cart-drawer";
  var ON_CART = /\/cart\/?$/.test(location.pathname);
  var TIB_KEY = "ezcd:tib3";            /* Ban-109b: v2 = only the full shop config from /cart */
  /* Ban-175 (anh 25/10 20:24, video iPhone: the crop window of the drawer's Edit design had no "Change photo"):
     on pages without Teeinblue (home, collections) the drawer runs Teeinblue with the copy of the shop settings kept in
     this browser, and that copy was renewed only when the customer opened /cart. Anh's iPhone still held the one from
     before "reupload photo in popup" was turned on (measured in the pane: the same copy with it off = no button). Now:
     v3 (every older copy is dropped at once) and a copy older than 1 hour is fetched again from /cart before use (the
     old one is used if that fails). */
  var TIB_OLD = "ezcd:tib2", TIB_AGE = 3600e3;
  var SCRIPT_SRC = (document.currentScript && document.currentScript.src) || "";
  /* Ban-174 (anh 25/10 17:53: 2 nút × vẫn còn sau Ban-173): file CSS này cũng mang ?v= của ez-cart-drawer.js → sửa riêng
     ez-cart-drawer.css (173) thì CDN vẫn trả bản cũ (đo /cart: ez-cart-drawer.css?v=…1792922885 = bản 171). Theme đưa địa chỉ đúng. */
  var CSS_URL = ((document.currentScript && document.currentScript.dataset) || {}).ezcdCss || SCRIPT_SRC.replace(/ez-cart-drawer(\.min)?\.js/, "ez-cart-drawer.css");
  /* Ban-116: the product page's own form styling + helpers (ez-personalize.css / .js), for the Edit popup on pages
     that do not have them (home, collections, /cart) — same folder, so the same URL pattern */
  /* Ban-171 (anh 25/10 16:32): built from this script's address, the URLs kept ITS ?v= (the CDN keeps a copy per
     address): on /cart, home and collections the Edit popup ran the ez-personalize of the day ez-cart-drawer.js was last
     saved (23/10 ~23:00, Ban-147: no "Change photo", no "+", no photo numbers). The theme now gives their own versioned addresses. */
  var ME = document.currentScript, EZP_DATA = (ME && ME.dataset) || {};
  var EZP_CSS = EZP_DATA.ezpCss || SCRIPT_SRC.replace(/ez-cart-drawer(\.min)?\.js/, "ez-personalize.css");
  var EZP_JS = EZP_DATA.ezpJs || SCRIPT_SRC.replace(/ez-cart-drawer(\.min)?\.js/, "ez-personalize.js");

  /* ---------- 1. Teeinblue: stay on the page after Add to Cart (this theme only) ----------
     Teeinblue goes to /cart when gotoCart is set or config.atc_action === "redirect" (shop-wide setting that LIVE
     still uses, so it is not changed in the admin). The objects it reads are patched here instead. */
  /* Ban-109b: and the "Edit design" button. Anh turned it on in Teeinblue (Store settings › Cart items), but the copy
     of the settings printed in a page can be older: the mug's campaign config and /cart still said
     show_edit_button: false on 21/10 07:30, so no button showed. Theme-side switch, same pages as above. */
  function noRedirect() {
    [window.teeinblueShopConfig, window.TeeInBlueShopConfig,
     window.teeinblueCampaign && window.teeinblueCampaign.config,
     window.TeeInBlueCampaign && window.TeeInBlueCampaign.config].forEach(function (c) {
      if (!c) return;
      c.show_edit_button = true;
      if (!ON_CART && c.atc_action === "redirect") c.atc_action = "default";
    });
  }
  noRedirect();

  /* ---------- 2. Teeinblue config for pages that do not load it ---------- */
  function saveTib() {
    try {
      var app = document.querySelector('script[src*="sdk.teeinblue.com/shopify/app-v1.js"]');
      if (!app) return;
      var cfg = null, list = document.scripts;
      if (window.teeinblueShopConfig) {                      /* /cart: the shop config script as Teeinblue prints it */
        for (var i = 0; i < list.length; i++) {
          var t = list[i].src ? "" : list[i].textContent;
          if (t && t.indexOf("window.teeinblueShopConfig") > -1 && t.indexOf("teeinblueCampaign") < 0) { cfg = t; break; }
        }
      }
      if (!cfg) return;
      var had = readTib();
      if (had && had.s === cfg && had.src === app.src && Date.now() - had.t < TIB_AGE / 2) return;
      localStorage.setItem(TIB_KEY, JSON.stringify({ s: cfg, src: app.src, t: Date.now() }));
    } catch (err) {}
  }
  function readTib() {
    try {
      if (localStorage.getItem(TIB_OLD) != null) localStorage.removeItem(TIB_OLD);
      var v = JSON.parse(localStorage.getItem(TIB_KEY) || "null");
      return v && v.s && v.src ? v : null;
    } catch (err) { return null; }
  }
  function tibFromCartPage() {
    return fetch(ROOT + "cart", { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (h) {
      var doc = new DOMParser().parseFromString(h, "text/html");
      var app = doc.querySelector('script[src*="sdk.teeinblue.com/shopify/app-v1.js"]');
      var cfg = null;
      Array.prototype.some.call(doc.querySelectorAll("script:not([src])"), function (s) {
        if (s.textContent.indexOf("window.teeinblueShopConfig") > -1) { cfg = s.textContent; return true; }
        return false;
      });
      if (!app || !cfg) return null;
      var v = { s: cfg, src: app.src, t: Date.now() };
      try { localStorage.setItem(TIB_KEY, JSON.stringify(v)); } catch (err) {}
      return v;
    }).catch(function () { return null; });
  }
  function tibLoaded() {
    return !!window.TEEINBLUE_APP || !!document.querySelector('script[src*="sdk.teeinblue.com/shopify/app-v1.js"]');
  }
  var tibLoading = null;
  function ensureTib() {
    if (tibLoaded()) return Promise.resolve(true);
    if (tibLoading) return tibLoading;
    var saved = readTib();
    var fresh = saved && saved.t && Date.now() - saved.t < TIB_AGE;
    tibLoading = (fresh ? Promise.resolve(saved) : tibFromCartPage().then(function (c) { return c || saved; })).then(function (c) {
      if (!c) return false;
      if (!window.teeinblueShopConfig) {
        var s = document.createElement("script");
        s.textContent = c.s;
        document.body.appendChild(s);
      }
      return new Promise(function (res) {
        var sc = document.createElement("script");
        sc.src = c.src;
        sc.onload = function () { res(true); };
        sc.onerror = function () { res(false); };
        document.body.appendChild(sc);
      });
    });
    return tibLoading;
  }
  function tibScan() {
    hooks();
    noRedirect();
    document.dispatchEvent(new Event("shopify-event-cart-ajax"));
  }
  function hooks() {
    var t = window.teeinblue = window.teeinblue || {};
    if (!t.handleCustomizationEditted || t.handleCustomizationEditted.ezcd) {
      var f = function () {
        dirty = false;
        saving = false;
        clearTimeout(saveT);
        restoreUrl();
        editEnd();
        if (isOpen) load({ edited: true }); else location.reload();
      };
      f.ezcd = 1;
      t.handleCustomizationEditted = f;
    }
  }
  function addons(scope) {
    var el = scope.querySelector(".ezcd__addons");
    if (!el) return;
    var list;
    try { list = JSON.parse(el.textContent); } catch (err) { return; }
    var cur = window.teeinblueAddonVariants = window.teeinblueAddonVariants || [];
    list.forEach(function (v) {
      if (v && !cur.some(function (x) { return x.id === v.id; })) cur.push(v);
    });
  }

  /* ---------- 3. shell (built once) ---------- */
  var root = null, panel = null, holder = null, confirmEl = null;
  var isOpen = false, adding = false, busy = false, opener = null, addTimer = 0;
  /* Ban-114 (anh 10:44 "vào trang SP có hàng trong giỏ: ngăn hiện ra rồi tắt rất nhanh"): vỏ ngăn được dựng lúc rảnh,
     TRƯỚC khi file CSS tải xong → vài khung không có CSS, rồi CSS tới và chạy hiệu ứng trượt ra (đo: 5.733 → 6.023 ms
     ngăn hiện ở x 32 → 389). Vỏ ẩn hẳn (display none) tới khi CSS tải xong; mở ngăn thì luôn hiện. */
  var cssOk = !CSS_URL;
  function cssReady() {
    cssOk = true;
    if (root && !isOpen) root.style.display = "";
    if (anotherEl) anotherEl.style.display = "";
  }
  function css() {
    if (!CSS_URL) return;
    var l = document.querySelector('link[data-ezcd-css]');
    if (l) return;
    l = document.createElement("link");
    l.rel = "stylesheet";
    l.href = CSS_URL;
    l.setAttribute("data-ezcd-css", "");
    l.onload = cssReady;
    l.onerror = cssReady;
    document.head.appendChild(l);
  }
  function shell() {
    if (root) return;
    css();
    root = document.createElement("div");
    root.className = "ezcd";
    root.setAttribute("aria-hidden", "true");
    if (!cssOk) root.style.display = "none";
    root.innerHTML =
      '<div class="ezcd__shade" data-ezcd="close"></div>' +
      '<section class="ezcd__panel" role="dialog" aria-modal="true" aria-labelledby="ezcd-title" tabindex="-1">' +
        '<div class="ezcd__holder"></div>' +
        '<div class="ezcd__adding" aria-live="polite"><span class="ezcd__spin" aria-hidden="true"></span><span>Adding your design to the cart…</span></div>' +
      '</section>';
    panel = root.querySelector(".ezcd__panel");
    holder = root.querySelector(".ezcd__holder");
    document.body.appendChild(root);
  }
  /* Ban-111: design preview (picture large + reminder), built once, over the drawer */
  var pvEl = null, pvBy = null;
  function pvShell() {
    if (pvEl) return;
    pvEl = document.createElement("div");
    pvEl.className = "ezcd-pv";
    pvEl.setAttribute("aria-hidden", "true");
    pvEl.innerHTML =
      '<div class="ezcd-pv__shade" data-ezcd="pvclose"></div>' +
      '<div class="ezcd-pv__box" role="dialog" aria-modal="true" aria-label="Your design" tabindex="-1">' +
        '<span class="ezcd__x ezcd-pv__x" role="button" tabindex="0" aria-label="Close preview" data-ezcd="pvclose">' +
          '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></span>' +
        '<p class="ezcd-pv__t">Your design</p>' +   /* Ban-114 (anh): không lấy tên SP (dài) */
        '<div class="ezcd-pv__img"><img alt="Your design" decoding="async"></div>' +
        '<p class="ezcd-pv__n">Please check names, dates and photos.</p>' +
        '<div class="ezcd-pv__acts">' +   /* Ban-113 (anh 10:09): popup nào cũng có nút đóng rõ ràng */
          '<span class="ezcd__btn ezcd__btn--line ezcd-pv__close" role="button" tabindex="0" data-ezcd="pvclose">Close</span>' +
          '<span class="ezcd__btn ezcd__btn--line ezcd-pv__edit" role="button" tabindex="0" data-ezcd="pvedit">Edit design</span>' +
          '<a class="ezcd__btn ezcd__btn--buy" href="' + ROOT + 'checkout" data-ezcd="checkout">Proceed to checkout</a>' +
        '</div>' +
      '</div>';
    document.body.appendChild(pvEl);
  }
  function openPv(el) {
    pvShell();
    pvBy = el;
    var li = el.closest(".ezcd-item");
    var img = pvEl.querySelector("img");
    img.removeAttribute("src");
    img._ezRetry = 0;
    var li2 = el.closest(".ezcd-item"), th = li2 && li2.querySelector(".ezcd-item__img img[data-fb]");
    if (th) img.setAttribute("data-fb", th.getAttribute("data-fb")); else img.removeAttribute("data-fb");
    img.onerror = function () { if (img.getAttribute("data-fb")) imgFail(img); };
    img.src = el.getAttribute("data-pv");
    pvEl.classList.toggle("no-edit", !(li && li.querySelector(".tee-edit-button")));
    pvEl.setAttribute("aria-hidden", "false");
    pvEl.classList.add("is-open");
    var box = pvEl.querySelector(".ezcd-pv__box");
    try { box.focus({ preventScroll: true }); } catch (err) {}
  }
  function closePv() {
    if (!pvEl || !pvEl.classList.contains("is-open")) return false;
    pvEl.classList.remove("is-open");
    pvEl.setAttribute("aria-hidden", "true");
    if (pvBy && pvBy.focus && pvBy.getAttribute("tabindex") === "0") { try { pvBy.focus({ preventScroll: true }); } catch (err) {} }
    pvBy = null;
    return true;
  }
  function confirmShell() {
    if (confirmEl) return;
    css();
    confirmEl = document.createElement("div");
    confirmEl.className = "ezcd-cf";
    confirmEl.setAttribute("aria-hidden", "true");
    confirmEl.innerHTML =
      '<div class="ezcd-cf__shade" data-ezcd="keep"></div>' +
      '<div class="ezcd-cf__box" role="alertdialog" aria-modal="true" aria-labelledby="ezcd-cf-t" aria-describedby="ezcd-cf-d" tabindex="-1">' +
        '<p class="ezcd-cf__t" id="ezcd-cf-t"></p>' +
        '<p class="ezcd-cf__d" id="ezcd-cf-d"></p>' +
        '<span class="ezcd__btn ezcd__btn--teal" role="button" tabindex="0" data-ezcd="keep"></span>' +
        '<span class="ezcd__btn ezcd__btn--line" role="button" tabindex="0" data-ezcd="discard"></span>' +
      '</div>';
    document.body.appendChild(confirmEl);
  }
  /* Ban-112: one box, two uses: "Discard your changes?" (edit popup) and "Remove this item?" (anh 09:41, like Pawfect) */
  var cfMode = "", rmLi = null, cfSheet = null;
  /* Ban-117 (anh 13:02): on the theme's own sheet (window.ezSheet, ez-floating-buttons.js — the "Photo tips" /
     "Estimated delivery" popup): bottom sheet on phones, closes with a pull down, ×, backdrop or Esc (= Keep).
     "Remove this item?" shows the customer's design (like Pawfect) so a slip does not cost them their work.
     No ezSheet (or another sheet already open) → the old box. */
  function cfOpen() {
    if (cfSheet) return cfSheet.box.isConnected && !cfSheet.box.classList.contains("is-leaving");
    return !!(confirmEl && confirmEl.classList.contains("is-open"));
  }
  function askSheet(mode, t, d, keep, go, img) {
    if (!window.ezSheet) return false;
    var sh = null;
    try {
      sh = window.ezSheet({
        title: t,
        cls: "ezcd-ship" + (mode === "rm" ? " is-danger" : ""),
        fill: function (body) {
          var h = "";
          if (img) h += '<img class="ezcd-ship__img" alt="" decoding="async">';
          h += '<p class="ezcd-ship__d"></p><div class="ezcd-ship__acts">' +
            '<span class="ezcd-ship__b ezcd-ship__b--keep" role="button" tabindex="0" data-ezcd="keep"></span>' +
            '<span class="ezcd-ship__b ezcd-ship__b--go" role="button" tabindex="0" data-ezcd="discard"></span></div>';
          body.innerHTML = h;
          if (img) body.querySelector(".ezcd-ship__img").src = img;
          body.querySelector(".ezcd-ship__d").textContent = d;
          body.querySelector(".ezcd-ship__b--keep").textContent = keep;
          body.querySelector(".ezcd-ship__b--go").textContent = go;
        },
        onClose: function (box) { if (cfSheet && cfSheet.box === box) cfSheet = null; }
      });
    } catch (err) { sh = null; }
    if (!sh) return false;
    cfMode = mode;
    cfSheet = sh;
    return true;
  }
  function ask(mode, t, d, keep, go, img) {
    if (askSheet(mode, t, d, keep, go, img)) return;
    confirmShell();
    cfMode = mode;
    confirmEl.querySelector(".ezcd-cf__t").textContent = t;
    confirmEl.querySelector(".ezcd-cf__d").textContent = d;
    confirmEl.querySelector('[data-ezcd="keep"].ezcd__btn').textContent = keep;
    confirmEl.querySelector('[data-ezcd="discard"]').textContent = go;
    confirmEl.classList.toggle("is-danger", mode === "rm");
    confirmEl.setAttribute("aria-hidden", "false");
    confirmEl.classList.add("is-open");
    var box = confirmEl.querySelector(".ezcd-cf__box");
    try { box.focus({ preventScroll: true }); } catch (err) {}
  }

  /* ---------- 4. open / close ---------- */
  function addLabel(t) { if (root) root.querySelector(".ezcd__adding span:last-child").textContent = t; }
  function open(by) {
    shell();
    setTimeout(function () { tibPrefetch(holder); }, 400);   /* Ban-122 */
    if (by) opener = by;
    hooks();
    if (isOpen) return;
    isOpen = true;
    var wasHidden = root.style.display === "none";
    root.style.display = "";
    root.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("ezcd-on");
    lockSync();
    /* next frame so the slide-in transition runs from the closed position (two frames when the shell was display none) */
    requestAnimationFrame(function () {
      (wasHidden ? requestAnimationFrame : function (f) { f(); })(function () {
        if (!isOpen) return;   /* Ban-123: đã đóng trước khi khung hình kế tiếp tới (khung trình duyệt ẩn / chạm nhanh) → không mở lại */
        root.classList.add("is-open");
        /* Ban-115 (anh 11:16: viền xanh bên trái ngăn khi mở lần đầu, viền vuông quanh icon giỏ sau khi đóng): đưa focus
           vào ngăn / trả về icon chỉ khi khách dùng bàn phím; chạm / chuột thì không (vòng focus là của bàn phím) */
        if (kbd) { try { panel.focus({ preventScroll: true }); } catch (err) { panel.focus(); } }
      });
    });
    tick();
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    adding = false;
    root.classList.remove("is-open", "is-adding");
    root.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("ezcd-on");
    if (!document.querySelector(".tee-edit-popup") && editOpen) { editOpen = false; draftBack(); editMark(false); }
    lockSync();
    stopTick();
    if (kbd && opener && opener.focus) { try { opener.focus({ preventScroll: true }); } catch (err) {} }
    else if (document.activeElement && (root.contains(document.activeElement) || document.activeElement === opener)) { try { document.activeElement.blur(); } catch (err) {} }
    opener = null;
  }

  /* ---------- 5. content ---------- */
  function sectionsUrl() { return ROOT + "?sections=" + SECTION; }
  /* Ban-120 (anh 16:07: mở giỏ thấy ảnh + nút Edit design "refresh nhẹ"): nội dung đã tải sẵn, lúc mở lại tải lần nữa và
     thay toàn bộ ngăn → ảnh vẽ lại, nút Edit design mất ~0,25 s chờ Teeinblue gắn lại. Nội dung không đổi (đo: 2 lần
     tải giống hệt từng ký tự) thì giữ nguyên ngăn. */
  var lastHtml = "";
  function render(html, note) {
    if (!html) return;
    lastHtml = html;
    var doc = new DOMParser().parseFromString(html, "text/html");
    var inn = doc.querySelector(".ezcd__in");
    if (!inn) return;
    addons(inn);
    /* Ban-147 (anh 23/10 22:47): đổi số lượng trong ngăn → cả ngăn vẽ lại từ HTML máy chủ, chỗ nút "Edit design" của Teeinblue
       trống tới khi Teeinblue vẽ lại (~0,3–0,4 s) → nút Edit chớp, "+ Add another" nhảy sang trái rồi về. Giữ lại nút Edit
       Teeinblue đã vẽ (cả khung div, app Teeinblue gắn trên nó) và đặt vào đúng dòng mới cùng mã thiết kế. */
    var keepEd = {};
    Array.prototype.forEach.call(holder.querySelectorAll(".tee-edit-customization[data-customization-id]"), function (d) {
      if (d.firstElementChild) keepEd[d.getAttribute("data-customization-id")] = d;
    });
    holder.innerHTML = "";
    holder.appendChild(document.importNode(inn, true));
    Array.prototype.forEach.call(holder.querySelectorAll(".tee-edit-customization[data-customization-id]"), function (d) {
      var id = d.getAttribute("data-customization-id"), old = keepEd[id];
      if (old && !d.firstElementChild) { d.parentNode.replaceChild(old, d); delete keepEd[id]; }
    });
    var n = parseInt(inn.getAttribute("data-count"), 10) || 0;
    var b = document.getElementById("header-cart-count-bubble");
    if (b) b.textContent = n;
    if (note) {
      var el = holder.querySelector("[data-ezcd-note]");
      if (el) {
        if (note.edited) el.lastElementChild.textContent = "Design updated";
        el.hidden = false;
        var first = holder.querySelector(".ezcd-item");       /* the line just added / just saved is the first one */
        if (first) first.classList.add("is-new");
        /* Ban-140: thêm từ "+ Add another" → nhãn trên dòng mới (dòng cũ vẫn còn bên dưới) */
        var fm = ANOTHER && !note.edited && first && first.querySelector(".ezcd-item__main");
        if (fm) {
          var tag = document.createElement("span");
          tag.className = "ezcd-item__tag";
          tag.textContent = "Added as new item";
          fm.insertBefore(tag, fm.firstChild);
        }
      }
    }
    imgFix(holder);
    if (note && note.edited) holdOld(holder);
    labelItems(holder);
    if (!editOpen && holder.querySelector(".tee-edit-customization")) ezp(false);   /* Ban-116: fetch the form styles ahead */
    if (isOpen) setTimeout(function () { tibPrefetch(holder); }, 400);   /* Ban-122: món mới / đã sửa */
    timerEl = holder.querySelector("[data-ezcd-timer] b");
    paintTick();
    if (holder.querySelector(".tee-edit-customization")) {
      ensureTib().then(function (ok) { if (ok) setTimeout(tibScan, tibLoaded() && window.TEEINBLUE_APP ? 0 : 400); });
    }
  }
  /* Ban-111: a line added a moment ago points at its design picture before Teeinblue has written it (blank square,
     21/10 08:05). Show the product picture meanwhile and swap the design in as soon as it exists. */
  function imgFail(im) {
    if (im._ezRetry) return;
    im._ezRetry = 1;
    var want = im.getAttribute("src"), n = 0;
    im.src = im.getAttribute("data-fb");
    (function again() {
      if (++n > 15 || !im.isConnected) return;
      var t = new Image();
      t.onload = function () { im.src = want; };
      t.onerror = function () { setTimeout(again, 1000); };      /* Ban-119: 2,5 → 1 s */
      t.src = want + (want.indexOf("?") < 0 ? "?" : "&") + "ezr=" + n;
    })();
  }
  /* Ban-114 (anh 10:44): dòng biến thể như trang /cart — đúng chữ khách thấy trên trang SP (nhãn chiến dịch Teeinblue,
     cùng bộ nhớ localStorage "ez-tib-labels:<product id>" mà cart.js và ez-personalize.js §… ghi), không lấy
     "Available Product" của Shopify. Cùng cách dựng nhãn với cart.js buildLabels (sửa một chỗ thì sửa cả hai). */
  var LABEL_KEY = "ez-tib-labels:", LABEL_TTL = 7 * 24 * 3600 * 1000, labelAsk = {};
  function niceLabel(s) {
    s = String(s || "").trim();
    return s && s === s.toUpperCase() ? s.charAt(0) + s.slice(1).toLowerCase() : s;
  }
  function buildLabels(j) {
    var out = {}, byTib = {}, cps = (j && j.campaign_products) || [];
    cps.forEach(function (cp) { (cp.campaign_variants || []).forEach(function (cv) { byTib[cv.variant_id] = { cp: cp, cv: cv }; }); });
    ((j && j.instance_variants) || []).forEach(function (iv) {
      var hit = byTib[iv.variant_id];
      if (!hit || !iv.platform_linked_id) return;
      var p = hit.cp.product || {}, v = hit.cv.variant || {}, rows = [];
      if (cps.length > 1) rows.push([niceLabel((j.config && j.config.available_product_label) || "Style"), hit.cp.platform_title || p.title || ""]);
      var color = hit.cv.color || v.color, size = hit.cv.size || v.size;
      if (color) rows.push([p.color_custom_label || "Color", color]);
      if (size) rows.push([p.size_custom_label || "Size", size]);
      out[String(iv.platform_linked_id)] = rows.filter(function (r) { return r[1] && !/^(default|default title|no)$/i.test(String(r[1]).trim()); });
    });
    return out;
  }
  function readLabels(pid) {
    try {
      var o = JSON.parse(localStorage.getItem(LABEL_KEY + pid) || "null");
      return o && o.t && Date.now() - o.t < LABEL_TTL ? o.v : null;
    } catch (err) { return null; }
  }
  function applyLabel(el, map) {
    var rows = map && map[el.getAttribute("data-ez-variant")];
    if (rows && rows.length) el.textContent = rows.map(function (r) { return r[0] + ": " + r[1]; }).join(" · ");
    el.classList.add("is-labelled");
  }
  function labelItems(box) {
    var els = box.querySelectorAll(".ezcd-item__v:not(.is-labelled)");
    if (!els.length) return;
    Array.prototype.forEach.call(els, function (el) {
      var pid = el.getAttribute("data-ez-product"), map = readLabels(pid);
      if (map) { applyLabel(el, map); return; }
      if (labelAsk[pid]) return;
      labelAsk[pid] = 1;
      var shop = (window.Shopify && window.Shopify.shop) || "";
      fetch("https://api.teeinblue.com/api/merchant/campaigns/" + encodeURIComponent(pid) + ".json?shop=" + encodeURIComponent(shop))
        .then(function (r) { return r.ok ? r.json() : r.status === 404 ? {} : null; })
        .then(function (j) {
          var m = j ? buildLabels(j) : null;
          if (m) { try { localStorage.setItem(LABEL_KEY + pid, JSON.stringify({ t: Date.now(), v: m })); } catch (err) {} }
          Array.prototype.forEach.call(box.querySelectorAll('.ezcd-item__v[data-ez-product="' + pid + '"]'), function (x) { applyLabel(x, m); });
        })
        .catch(function () {})
        .then(function () { labelAsk[pid] = 0; });
    });
    setTimeout(function () {   /* mạng chậm / lỗi: hiện chữ dự phòng */
      Array.prototype.forEach.call(box.querySelectorAll(".ezcd-item__v:not(.is-labelled)"), function (x) { x.classList.add("is-labelled"); });
    }, 2000);
  }
  function imgFix(scope) {
    Array.prototype.forEach.call(scope.querySelectorAll(".ezcd-item__img img[data-fb]"), function (im) {
      if (im.complete && im.naturalWidth === 0) imgFail(im);
      else im.addEventListener("error", function () { imgFail(im); }, { once: true });
    });
  }
  /* Ban-119 (anh 15:17: ảnh trong giỏ hiện chậm khi mở, chậm sau khi sửa): ảnh thiết kế nằm ở cdn.teeinblue.com
     (~95 KB, ~0,5 s mỗi ảnh, không có cỡ nhỏ) và là loading="lazy" trong ngăn đang ẩn → chỉ bắt đầu tải khi ngăn mở.
     Giờ: nội dung ngăn tải sẵn lúc rảnh (Ban-112) thì tải luôn ảnh (vào bộ nhớ đệm trình duyệt, 1 năm); sau Thêm / Save,
     ngăn chờ ảnh mới (Save tối đa 4 s, Thêm 1,5 s; thử lại khi CDN chưa có ảnh) rồi mới vẽ lại → không còn ô xám trống; Save: ảnh mới tải từ lúc Teeinblue vừa thêm
     xong (đọc cart.js), song song với phần Teeinblue còn làm (~2 s). */
  var imgP = {};
  var TIB_IMG = /https:\/\/cdn\.teeinblue\.com\/customizations\/[^"'\s<>?\\]+/g;
  /* tải 1 ảnh vào bộ nhớ đệm; ảnh thiết kế vừa tạo chưa có ngay trên cdn.teeinblue.com (đo 21/10: lỗi lúc ngăn vẽ lại
     sau Save → hiện ảnh SP chung, ảnh thật hiện sau mấy giây) → thử lại mỗi 0,7 s, tối đa `tries` lần */
  function imgLoad(u, tries) {
    var rec = imgP[u];
    if (rec && rec.ok !== false) return rec.pr;
    rec = imgP[u] = { ok: null };
    rec.pr = new Promise(function (done) {
      var n = 0;
      (function go() {
        var im = new Image();
        im.onload = function () { rec.ok = true; done(true); };
        im.onerror = function () {
          if (++n < (tries || 1)) setTimeout(go, 700);
          else { rec.ok = false; done(false); }
        };
        im.src = u;
      })();
    });
    return rec.pr;
  }
  function urlsIn(s) {
    var m = String(s || "").replace(/&amp;/g, "&").replace(/\\\//g, "/").match(TIB_IMG);
    return m ? m.filter(function (u, i) { return m.indexOf(u) === i; }).slice(0, 8) : [];
  }
  function preImg(urls, ms, tries) {
    var all = Promise.all(urls.map(function (u) { return imgLoad(u, tries); }));
    return ms ? Promise.race([all, new Promise(function (ok) { setTimeout(ok, ms); })]) : all;
  }
  var editPrevImg = "", editPh = "";
  function holdOld(box) {
    var im = box.querySelector(".ezcd-item .ezcd-item__img img"), u = im && im.getAttribute("src");
    var old = editPrevImg;
    editPrevImg = "";
    if (!im || !old || old === u || !TIB_IMG.test(u) || (imgP[u] && imgP[u].ok)) { TIB_IMG.lastIndex = 0; return; }
    TIB_IMG.lastIndex = 0;
    im._ezRetry = 1;                                   /* imgFail không đổi sang ảnh SP chung */
    im.src = old;
    im.parentNode.classList.add("is-upd");
    imgLoad(u, 15).then(function (ok) {
      if (!im.isConnected) return;
      im.parentNode.classList.remove("is-upd");
      im.src = u;
      if (!ok) { im._ezRetry = 0; if (im.complete && !im.naturalWidth) imgFail(im); }
    });
  }
  function preCart() {
    fetch(ROOT + "cart.js", { credentials: "same-origin" })
      .then(function (r) { return r.text(); })
      .then(function (t) { preImg(urlsIn(t), 0, 9); })
      .catch(function () {});
  }
  function load(note) {
    shell();
    busy = true;
    return fetch(sectionsUrl(), { credentials: "same-origin" })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var html = j[SECTION], urls = urlsIn(html);
        /* ảnh thiết kế mới có trên CDN sau ~5–8 s kể từ lúc bấm (đo 21/10). Thêm vào giỏ: chờ tối đa 1,5 s rồi vẽ (khách cần
           thấy món đã vào giỏ; chưa có ảnh thì imgFail thử lại mỗi 1 s). Save: vẽ ngay ("Design updated"), món vừa sửa
           giữ ảnh cũ (mờ nhẹ) tới khi ảnh mới tải xong rồi đổi — không ô trống, không ảnh SP chung (holdOld). */
        var wait = note && !note.edited ? preImg(urls, 1500, 6) : (preImg(urls), null);
        return Promise.resolve(wait).then(function () {
          busy = false;
          root.classList.remove("is-adding", "is-saving");
          if (!note && html === lastHtml && holder.querySelector(".ezcd__in")) return;   /* không đổi: không vẽ lại */
          render(html, note);
        });
      })
      .catch(function () { busy = false; root.classList.remove("is-adding"); });
  }
  function change(li, qty) {
    if (busy) return;
    busy = true;
    li.classList.add("is-busy");
    /* Ban-111: the new number shows at once; Shopify's answer (section redraw ~1.7 s on 21/10) follows */
    var qn = li.querySelector(".ezcd-qty__n");
    if (qn && qty > 0) qn.textContent = qty;
    if (qty === 0) li.classList.add("is-going");
    fetch((R.cart_change_url || ROOT + "cart/change") + ".js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: li.getAttribute("data-key"), quantity: qty, sections: SECTION, sections_url: location.pathname })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        busy = false;
        if (res.ok && res.j.sections) render(res.j.sections[SECTION]);
        else load();
      })
      .catch(function () { busy = false; load(); });
  }

  /* ---------- 6. 10-minute line (same text and reset as /cart, cart.js initCartCountdown; anh keeps it) ---------- */
  var left = 600, timerEl = null, tickId = 0;
  function paintTick() {
    if (!timerEl) return;
    if (left <= 0) {
      var p = timerEl.parentNode;
      if (p) p.textContent = "Forgot one final step? Place your order now and make the payment right away!";
      timerEl = null;
      return;
    }
    var m = Math.floor(left / 60), s = left % 60;
    timerEl.firstChild ? (timerEl.firstChild.nodeValue = (m < 10 ? "0" : "") + m + ":" + (s < 10 ? "0" : "") + s)
                       : timerEl.appendChild(document.createTextNode(""));
  }
  function tick() {
    if (tickId) return;
    tickId = setInterval(function () { if (left > 0) left--; paintTick(); }, 1000);
  }
  function stopTick() { clearInterval(tickId); tickId = 0; }

  /* ---------- 7. hold the page behind (no overflow lock: iPhone toolbar → resize → Teeinblue redraw, Ban-81→85) ---------- */
  var touchY = 0, editOpen = false;
  var FINE = window.matchMedia ? window.matchMedia("(hover: hover) and (pointer: fine)") : null;
  /* Ban-109b (anh 07:23: the page scrollbar still showed and the page behind still moved; Pawfect locks the page).
     Mouse/trackpad: lock the page itself (html overflow hidden; scrollbar-gutter keeps its width so nothing shifts).
     Touch: no overflow lock (iPhone toolbar → resize → Teeinblue redraw, Ban-81→85), drags are held instead. */
  function lockSync() {
    var on = isOpen || editOpen;
    document.documentElement.classList.toggle("ezcd-lock", on && !!FINE && FINE.matches);
    document.documentElement.classList.toggle("ezcd-modal", on);          /* Ban-111: floating buttons hide */
    holdOn(on);
  }
  var editT = 0;
  /* Ban-117 (anh: × của popup Edit vẫn "chạm" × của ngăn): ngón tay nhả trên × của ngăn bên dưới → ĐT tô nút (hover dính).
     Ngăn không nhận chạm khi popup Edit mở và 0,7 s sau khi nó đóng (click đã chặn từ Ban-115). */
  function editMark(on) {
    clearTimeout(editT);
    if (on) document.documentElement.classList.add("ezcd-editing");
    else editT = setTimeout(function () { document.documentElement.classList.remove("ezcd-editing"); }, 700);
  }
  /* Ban-118: Teeinblue lưu bản nháp form theo SP ("teeinblue-customizations") cả khi khách sửa trong popup Edit rồi Cancel
     → lần sau vào trang SP, form "Welcome back" mang giá trị của món trong giỏ. Chụp lại lúc mở, trả về lúc đóng
     (Save vẫn cập nhật món trong giỏ như thường). Chỉ đọc / ghi localStorage 2 lần, không gọi mạng. */
  var DRAFT_KEY = "teeinblue-customizations", draft;
  function draftKeep() {
    if (draft !== undefined) return;
    try { draft = localStorage.getItem(DRAFT_KEY); } catch (err) { draft = undefined; }
  }
  function draftBack() {
    if (draft === undefined) return;
    var d = draft;
    draft = undefined;
    function put() {
      try {
        if (d === null) localStorage.removeItem(DRAFT_KEY);
        else if (localStorage.getItem(DRAFT_KEY) !== d) localStorage.setItem(DRAFT_KEY, d);
      } catch (err) {}
    }
    put();
    setTimeout(function () { if (draft === undefined) put(); }, 800);   /* Teeinblue có thể ghi chậm sau khi đóng */
  }
  function editStart() { editOpen = true; draftKeep(); lockSync(); editMark(true); ezp(true); editDecor(0); }
  /* Ban-116 (anh 11:16: popup Edit phải là đúng form trang SP, nhất là nhiều ảnh). Trang SP đã có ez-personalize
     (form của trang + form trong popup, ez-personalize Ban-116 làm đẹp mọi form). Trang khác: nạp ez-personalize.css
     (bật chỉ khi popup Edit mở — tệp này còn chỉnh vài thứ của trang SP như sao Judge.me, không để lọt ra trang chủ)
     và ez-personalize.js (một lần; window.ezpForms() làm đẹp form đang có). CSS chèn TRƯỚC ez-cart-drawer.css để
     quy tắc riêng của popup Edit vẫn thắng. */
  var ezpLink = null, ezpJs = false;
  function ezpOnPage() { return !!document.querySelector('script[src*="ez-personalize"]:not([data-ezcd-ezp])'); }
  function ezp(on) {
    if (!SCRIPT_SRC || ezpOnPage()) return;
    if (!ezpLink) {
      ezpLink = document.createElement("link");
      ezpLink.rel = "stylesheet";
      ezpLink.href = EZP_CSS;
      ezpLink.setAttribute("data-ezcd-ezp", "");
      ezpLink.media = on ? "all" : "not all";             /* "not all": downloaded now, applied later */
      var mine = document.querySelector("link[data-ezcd-css]");
      document.head.insertBefore(ezpLink, mine || null);
    } else ezpLink.media = on ? "all" : "not all";
    if (on && !ezpJs && !window.ezpForms) {
      ezpJs = true;
      var sc = document.createElement("script");
      sc.src = EZP_JS;
      sc.setAttribute("data-ezcd-ezp", "");
      sc.onload = function () { if (window.ezpForms) window.ezpForms(); };
      document.body.appendChild(sc);
    }
  }
  /* Ban-113: (1) hình sống: Teeinblue vẽ svg với preserveAspectRatio "xMidYMin slice" → trong khung cố định của ta
     bị cắt mất phần dưới (ĐT 375 mất chân "2026"); "meet" = nằm trọn trong khung. (2) nút "Cancel" cạnh Save changes
     (anh 10:09: popup nào cũng có nút đóng). Popup dựng không đồng bộ (~0,4–1,5 s) → thử lại 250 ms, tối đa 6 s. */
  function editDecor(n) {
    var P = document.querySelector(".tee-edit-popup");
    /* Ban-122: mạng yếu → Teeinblue có thể cần > 6 s mới dựng form; trước đây hết 6 s là bỏ (không nút Cancel, không tìm
       ảnh sống → lộ hình thiết kế trần). Giờ chờ tới 20 s; lần thử đầu sau 50 ms để ảnh chờ hiện ngay */
    if (!P) { if (n < 80) setTimeout(function () { editDecor(n + 1); }, n < 3 ? 50 : 250); return; }
    var svg = P.querySelector(".teeinblue-hidden svg");
    if (svg && svg.getAttribute("preserveAspectRatio") !== "xMidYMid meet") svg.setAttribute("preserveAspectRatio", "xMidYMid meet");
    var acts = P.querySelector("#teeFormActions");
    if (acts && !acts.querySelector(".ezcd-ecancel")) {
      var c = document.createElement("span");
      c.className = "ezcd-ecancel";
      c.setAttribute("role", "button");
      c.setAttribute("tabindex", "0");
      c.setAttribute("data-ezcd", "editcancel");
      c.textContent = "Cancel";
      acts.insertBefore(c, acts.firstChild);
    }
    if (acts && window.ezpForms && !acts._ezpDone) { acts._ezpDone = 1; try { window.ezpForms(); } catch (err) {} }   /* Ban-116 */
    if (editPh && !P._ezcdPh) { P._ezcdPh = editPh; P.style.setProperty("--ezcd-ph", 'url("' + editPh.replace(/"/g, "%22") + '")'); P.classList.add("ezcd-hasph"); }
    if (acts) liveMock(P, 0);
    if ((!svg || !acts) && n < 80) setTimeout(function () { editDecor(n + 1); }, 250);
  }
  /* Ban-117 (anh 13:02: live preview trong popup xấu hơn trang SP; Family Tree bị thu nhỏ). Popup vẽ hình thiết kế trần
     (.teeinblue-hidden svg, khổ file thiết kế: Family Tree 500×250). Trang SP dùng ảnh mockup sống của Teeinblue (slide có
     .tee-printarea--printarea, vẽ lại khi khách sửa); popup có sẵn đúng gallery đó (.editor-gallery-wrapper) nhưng mở ở
     ảnh 1 (Family Tree: mockup sống là ảnh 6) → tìm bằng các ảnh nhỏ.
     Ban-118 (anh 13:53: ảnh nhảy, đổi cách hiện sau một lúc): thẻ ảnh có sẵn đúng chỗ, đúng cỡ ngay khi popup mở (CSS),
     gallery được bày từ đầu nên không phải đo lại; JS chỉ tìm rồi bật .ezcd-live (ảnh hiện dần) hoặc .ezcd-nolive
     (không có mockup sống → hình thiết kế, cùng chiều cao). Nhớ ảnh số mấy theo campaign (localStorage) → lần sau 1 bước. */
  var LIVE_KEY = "ezcd:live";
  function liveMemo(k, v) {
    try {
      var m = JSON.parse(localStorage.getItem(LIVE_KEY) || "{}");
      if (v === undefined) return k in m ? m[k] : null;
      m[k] = v;
      var ks = Object.keys(m);
      if (ks.length > 40) delete m[ks[0]];
      localStorage.setItem(LIVE_KEY, JSON.stringify(m));
    } catch (err) {}
    return null;
  }
  function liveMock(P, n) {
    if (P._ezcdLive) return;
    var g = P.querySelector(".editor-gallery-wrapper .tee-gallery");
    if (!g || !g.querySelector(".tee-slide--active")) {
      if (n < (P._ezcdPh ? 80 : 24)) setTimeout(function () { liveMock(P, n + 1); }, 250);   /* Ban-122: có ảnh chờ → chờ tới 20 s */
      else if (P.isConnected) P.classList.add("ezcd-nolive");
      return;
    }
    P._ezcdLive = 1;
    var th = g.querySelectorAll(".tee-thumbnails__track .tee-thumbnail");
    var t0 = th[0] && th[0].querySelector("img");
    var key = t0 ? String(t0.getAttribute("src") || "").split("?")[0].slice(-80) : "";
    var memo = key ? liveMemo(key) : null;
    var order = [];
    if (typeof memo === "number" && memo >= 0 && memo < th.length) order.push(memo);
    for (var k = 0; k < th.length; k++) if (k !== memo) order.push(k);
    var i = -1, wait = 0, ready = 0, t1 = 0;
    var hasMemo = typeof memo === "number" && memo >= 0 && memo < th.length;
    function done(ok, idx, cut) {
      if (!P.isConnected) return;
      P.classList.add(ok ? "ezcd-live" : "ezcd-nolive");
      if (key && (ok || (!hasMemo && !cut))) liveMemo(key, ok ? idx : -1);   /* nhớ ảnh số mấy; "không có" chỉ khi đã tìm hết từ đầu */
      if (ok) liveZoom(P);
    }
    function activeIdx() {
      var sl = g.querySelectorAll(".tee-slider__track > .tee-slide");
      for (var j = 0; j < sl.length; j++) if (sl[j].classList.contains("tee-slide--active")) return j;
      return -1;
    }
    if (memo === -1) { done(false); return; }                       /* campaign này không có mockup sống */
    /* vùng in sống chỉ có khi Teeinblue đã đọc xong thiết kế (đo: bấm ngay khi popup vừa dựng → ảnh 6 chưa có vùng in,
       tìm hết 6 ảnh rồi kết luận sai). Chờ hình thiết kế (.teeinblue-hidden svg) có nội dung, tối đa 4 s. */
    (function warm() {
      if (!P.isConnected) return;
      var sv = P.querySelector(".teeinblue-item > .teeinblue-hidden svg");
      if (!(sv && sv.querySelector("g")) && ready < (P._ezcdPh ? 15000 : 4000)) { ready += 100; setTimeout(warm, 100); return; }
      if (hasMemo) { i = 0; th[memo].click(); }                    /* đã biết: đi thẳng */
      t1 = Date.now();
      setTimeout(check, 50);
    })();
    /* mỗi ảnh: chờ Teeinblue dựng xong (.tee-mockup-item--loaded; ảnh đã nhớ: tới khi có vùng in, tối đa 2,5 s; ảnh khác
       tối đa 1 s) rồi xem có vùng in sống không. setTimeout, không dùng rAF (thẻ trình duyệt ẩn thì rAF dừng hẳn) */
    function check() {
      if (!P.isConnected) return;
      var a = g.querySelector(".tee-slide--active"), it = a && a.querySelector(".tee-mockup-item");
      if (a && a.querySelector(".tee-printarea--printarea")) { done(true, i < 0 ? activeIdx() : order[i]); return; }
      /* tìm tối đa 4,5 s rồi về hình thiết kế (không nhớ "không có" — có thể chỉ do mạng chậm).
         Ban-122 (anh 18:58: mạng yếu thì popup lộ hình thiết kế trần thay vì mockup): có ảnh chờ (ảnh thiết kế đã lưu,
         đúng kiểu mockup) thì chờ ảnh sống tới 20 s, trong lúc đó thẻ hiện ảnh chờ */
      if (Date.now() - t1 > (P._ezcdPh ? 20000 : 4500)) { done(false, 0, 1); return; }
      var loaded = it && it.classList.contains("tee-mockup-item--loaded");
      var memoNow = hasMemo && i === 0;
      /* Teeinblue có thể đưa slider về ảnh 1 khi vừa dựng xong (đo: bấm ảnh 6 ngay khi mở lại → về ảnh 5 / 1) → bấm lại */
      var off = i >= 0 && activeIdx() !== order[i];
      if (off && wait % 300 === 0) th[order[i]].click();
      if ((memoNow ? wait < 2500 : ((off || !loaded) && wait < 1500))) { wait += 50; setTimeout(check, 50); return; }
      wait = 0;
      if (++i >= order.length) { done(false); return; }
      th[order[i]].click();
      setTimeout(check, 50);
    }
  }
  /* Ban-122 (anh 18:58: live preview popup Edit chậm rõ, Pawfect nhanh hơn). Đo (21/10, ĐT, cache ấm): bấm Edit → popup
     0,03 s → form + hình 0,76 s → ảnh sống 1,29 s; 0,4–0,6 s đầu chỉ là chờ 2 lệnh gọi Teeinblue (dữ liệu campaign 57 KB,
     thiết kế đã lưu 3 KB) — ảnh mockup / ảnh khách chỉ bắt đầu tải sau đó. Teeinblue thêm "&v=<giờ mở trang>" vào địa chỉ
     campaign nên tải trước bằng cache trình duyệt không trúng. Cách làm: khi ngăn giỏ / trang giỏ mở, tải trước 2 dữ liệu đó
     cho các món có thiết kế (mỗi campaign một lần) và mở sẵn kết nối tới máy chủ Teeinblue; lúc popup Edit mở, lệnh gọi
     của Teeinblue nhận ngay bản đã tải. Chỉ khi popup Edit đang mở, chỉ 2 địa chỉ đó; lỗi / chưa có thì đi đường thường. */
  var preCamp = {}, preCust = {}, preWrapped = false, preConn = false;
  function preGet(f, u) {
    return f(u, { credentials: "omit" }).then(function (r) { return r.ok ? r.text() : null; }).catch(function () { return null; });
  }
  function tibPrefetch(box) {
    var shop = window.Shopify && window.Shopify.shop, cn = navigator.connection;
    if (!box || !shop || !window.fetch || !window.Response || (cn && cn.saveData)) return;
    var els = box.querySelectorAll("[data-pid] .tee-edit-customization[data-customization-id], [data-pid][data-ez-design]");
    if (!els.length) return;
    if (!preConn) {
      preConn = true;
      [["https://api.teeinblue.com", 1], ["https://cdn.teeinblue.com", 0], ["https://cdnx.teeinblue.com", 0]].forEach(function (h) {
        var l = document.createElement("link");
        l.rel = "preconnect";
        l.href = h[0];
        if (h[1]) l.crossOrigin = "anonymous";
        document.head.appendChild(l);
      });
    }
    if (!preWrapped) {
      preWrapped = true;
      var nf = window.fetch;
      window.fetch = function (u, o) {
        if (editOpen && typeof u === "string" && u.indexOf("api.teeinblue.com/api/merchant/") > 0 && !(o && o.method && o.method !== "GET")) {
          var m = u.match(/\/merchant\/campaigns\/(\d+)\.json/), m2 = !m && u.match(/\/merchant\/shopify\/customization\/([\w-]+)/);
          var p = m ? preCamp[m[1]] : m2 ? preCust[m2[1]] : null;
          if (p) {
            var self = this, args = arguments;
            return p.then(function (t) {
              return t ? new Response(t, { status: 200, headers: { "Content-Type": "application/json" } }) : nf.apply(self, args);
            });
          }
        }
        return nf.apply(this, arguments);
      };
      preGet.f = nf;
    }
    var api = "https://api.teeinblue.com/api/merchant/", q = "?shop=" + encodeURIComponent(shop), n = 0;
    Array.prototype.forEach.call(els, function (el) {
      var row = el.closest("[data-pid]"), pid = row && row.getAttribute("data-pid");
      var cid = el.getAttribute("data-customization-id") || el.getAttribute("data-ez-design");
      if (!pid || !cid || n >= 8) return;
      if (!preCamp[pid]) { n++; preCamp[pid] = preGet(preGet.f, api + "campaigns/" + pid + ".json" + q + "&v=" + Date.now()); }
      if (!preCust[cid]) preCust[cid] = preGet(preGet.f, api + "shopify/customization/" + encodeURIComponent(cid) + q);
    });
  }
  /* Ban-118: zoom trên thẻ Live preview của popup, như thẻ nổi trang SP (ez-personalize §38): + / − (1 → 1,5 → 2 → 2,5×),
     kéo để xem khi đã phóng, chạm đúp = phóng 2× tại chỗ / về 1×. Chỉ dời track của slider (biến CSS). Chạm / kéo trên ảnh
     không tới slider của Teeinblue (vuốt ngang của nó sẽ đổi sang ảnh khác). Listener gắn trên chính thẻ. */
  function liveZoom(P) {
    var host = P.querySelector(".editor-gallery-wrapper .tee-gallery-content");
    if (!host || host._ezcdZ) return;
    host._ezcdZ = 1;
    var STEPS = [1, 1.5, 2, 2.5], MAX = 2.5, s = 1, x = 0, y = 0;
    var SV = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">';
    var pill = document.createElement("div");
    pill.className = "ezcd-z";
    pill.innerHTML = '<span class="ezcd-z__b" role="button" tabindex="0" aria-label="Zoom in" data-z="1">' + SV + '<path d="M12 6.5v11M6.5 12h11"/></svg></span>' +
      '<span class="ezcd-z__b is-off" role="button" tabindex="0" aria-label="Zoom out" data-z="-1">' + SV + '<path d="M6.5 12h11"/></svg></span>';
    host.appendChild(pill);
    var bIn = pill.firstChild, bOut = pill.lastChild;
    function track() { return host.querySelector(".tee-slider__track"); }
    function apply(anim) {
      var t = track(), w = t ? t.offsetWidth : 0, h = t ? t.offsetHeight : 0;
      var mx = w * (s - 1) / 2, my = h * (s - 1) / 2;
      x = Math.max(-mx, Math.min(mx, x));
      y = Math.max(-my, Math.min(my, y));
      host.classList.toggle("is-anim", !!anim);
      host.classList.toggle("is-zoom", s > 1.001);
      host.style.setProperty("--ezcd-zs", String(Math.round(s * 1000) / 1000));
      host.style.setProperty("--ezcd-zx", Math.round(x) + "px");
      host.style.setProperty("--ezcd-zy", Math.round(y) + "px");
      bOut.classList.toggle("is-off", s <= 1.001);
      bIn.classList.toggle("is-off", s >= MAX - 0.001);
    }
    function zoomTo(nz, qx, qy, anim) {
      nz = Math.max(1, Math.min(MAX, nz));
      x = qx - nz * (qx - x) / s;
      y = qy - nz * (qy - y) / s;
      s = nz;
      if (s <= 1.001) { s = 1; x = 0; y = 0; }
      apply(anim);
    }
    function step(dir) {
      var nz = s, j;
      if (dir > 0) { for (j = 0; j < STEPS.length; j++) if (STEPS[j] > s + 0.01) { nz = STEPS[j]; break; } }
      else { nz = 1; for (j = STEPS.length - 1; j >= 0; j--) if (STEPS[j] < s - 0.01) { nz = STEPS[j]; break; } }
      zoomTo(nz, 0, 0, true);
    }
    function local(cx, cy) {
      var r = host.getBoundingClientRect();
      return [cx - (r.left + r.width / 2), cy - (r.top + r.height / 2)];
    }
    pill.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      var b = e.target.closest && e.target.closest(".ezcd-z__b");
      if (b && !b.classList.contains("is-off")) step(+b.getAttribute("data-z"));
    });
    pill.addEventListener("keydown", function (e) {
      if (e.key !== "Enter" && e.key !== " ") return;
      var b = e.target.closest && e.target.closest(".ezcd-z__b");
      if (!b) return;
      e.preventDefault();
      e.stopPropagation();
      if (!b.classList.contains("is-off")) step(+b.getAttribute("data-z"));
    });
    /* Ban-119 (anh 15:17: ĐT không dùng 2 ngón để zoom như trang SP): cử chỉ như thẻ nổi trang SP (ez-personalize §38,
       Ban-37/51): 1 ngón kéo khi đã phóng, 2 ngón phóng quanh điểm giữa 2 ngón (cả từ 1×), chạm đúp 2× / về 1×.
       Không setPointerCapture (iPhone giữ "ngón ảo" → Ban-37). Trình duyệt chỉ được cuộn dọc trên ảnh (CSS pan-y);
       khi có ngón thứ 2, pinch của trình duyệt bị huỷ (touch* / gesture* preventDefault) → không phóng cả trang. */
    var pts = {}, nPts = 0, start = null, moved = false, lastTap = null;
    function snap() {
      var ids = Object.keys(pts), a = pts[ids[0]], b = pts[ids[1]] || a;
      return { s: s, x: x, y: y, cx: (a.x + b.x) / 2, cy: (a.y + b.y) / 2, d: Math.hypot(a.x - b.x, a.y - b.y) || 1 };
    }
    host.addEventListener("pointerdown", function (e) {
      if (pill.contains(e.target)) return;
      e.stopPropagation();
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      nPts = Object.keys(pts).length;
      moved = false;
      start = snap();
      start.t = Date.now(); start.x0 = e.clientX; start.y0 = e.clientY;
    }, true);
    host.addEventListener("pointermove", function (e) {
      if (!pts[e.pointerId] || !start) return;
      e.stopPropagation();
      pts[e.pointerId] = { x: e.clientX, y: e.clientY };
      if (Math.abs(e.clientX - start.x0) + Math.abs(e.clientY - start.y0) > 6) moved = true;
      if (s <= 1.001 && nPts < 2) return;               /* chưa phóng, 1 ngón: để cuộn form như thường */
      var now = snap();
      if (nPts > 1) {
        var n = Math.max(1, Math.min(MAX, start.s * now.d / start.d));
        var q = start.q || (start.q = local(start.cx, start.cy));
        x = q[0] - n * (q[0] - start.x) / start.s + (now.cx - start.cx);
        y = q[1] - n * (q[1] - start.y) / start.s + (now.cy - start.cy);
        s = n;
      } else {
        x = start.x + (now.cx - start.cx);
        y = start.y + (now.cy - start.cy);
      }
      apply(false);
    }, true);
    function up(e) {
      if (!pts[e.pointerId]) return;
      e.stopPropagation();
      delete pts[e.pointerId];
      nPts = Object.keys(pts).length;
      if (nPts) { start = snap(); start.t = Date.now(); start.x0 = start.cx; start.y0 = start.cy; return; }
      if (s < 1.02 && s !== 1) zoomTo(1, 0, 0, true);
      if (e.type === "pointerup" && !moved && start && Date.now() - start.t < 300) {
        var t = Date.now();
        if (lastTap && t - lastTap.t < 320 && Math.abs(e.clientX - lastTap.x) < 30 && Math.abs(e.clientY - lastTap.y) < 30) {
          lastTap = null;
          if (s > 1.001) zoomTo(1, 0, 0, true);
          else { var q = local(e.clientX, e.clientY); zoomTo(2, q[0], q[1], true); }
        } else lastTap = { t: t, x: e.clientX, y: e.clientY };
      }
      start = null;
    }
    host.addEventListener("pointerup", up, true);
    host.addEventListener("pointercancel", up, true);
    /* vuốt / kéo chuột của slider Teeinblue (touch*, mouse*) dừng ở thẻ: ảnh sống luôn là ảnh đang hiện */
    ["touchstart", "touchmove", "touchend", "touchcancel", "mousedown", "mousemove", "mouseup", "dragstart"].forEach(function (ev) {
      host.addEventListener(ev, function (e) {
        if (pill.contains(e.target)) return;
        e.stopPropagation();
        if (ev === "dragstart") e.preventDefault();
        if ((ev === "touchmove" || ev === "touchstart") && e.cancelable && ((e.touches && e.touches.length > 1) || (ev === "touchmove" && s > 1.001))) e.preventDefault();
      }, { capture: true, passive: ev !== "touchmove" && ev !== "touchstart" });
    });
    ["gesturestart", "gesturechange"].forEach(function (ev) {          /* iPhone Safari */
      host.addEventListener(ev, function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    });
    apply(false);
  }
  /* Cancel = như bấm × : đã sửa thì hỏi "Discard your changes?", chưa sửa thì đóng luôn */
  function editCancel() {
    var x = document.querySelector(".tee-edit-popup .tee-dialog-close");
    if (!x) return;
    if (dirty) { askDiscard(x); return; }
    letClose = true;
    x.click();
    letClose = false;
    restoreSoon();
  }
  function editEnd() { editOpen = false; draftBack(); lockSync(); editMark(false); ezp(false); }
  function canScroll(el, dy) {
    return dy < 0 ? el.scrollTop > 0 : el.scrollTop + el.clientHeight < el.scrollHeight - 1;
  }
  function inOther(t) { return t && t.closest && t.closest(".vm--container:not(.tee-edit-popup), .ezcd-cf, .ezcd-pv, .ezp-ship, .ezp-ai"); }   /* Ban-116: + photo sheet / photo processing */
  function scroller(t) {
    if (!t || !t.closest) return null;
    if (t.closest(".tee-edit-popup")) return t.closest(".tee-dialog-body");
    return t.closest("[data-ezcd-scroll]");
  }
  function onWheel(e) {
    if (editGone() && !isOpen) return;
    if (!(isOpen || editOpen) || e.ctrlKey || inOther(e.target)) return;
    var sc = scroller(e.target);
    if (!sc || !canScroll(sc, e.deltaY)) e.preventDefault();
  }
  function onTouchStart(e) { if (e.touches.length === 1) touchY = e.touches[0].clientY; }
  function onTouchMove(e) {
    if (editGone() && !isOpen) return;
    if (!(isOpen || editOpen) || !e.cancelable || e.touches.length !== 1 || inOther(e.target)) return;
    var y = e.touches[0].clientY, dy = touchY - y;
    touchY = y;
    if (!dy) return;
    var sc = scroller(e.target);
    if (!sc || !canScroll(sc, dy)) e.preventDefault();
  }
  var holdIs = false;
  function holdOn(on) {
    if (on === holdIs) return;
    holdIs = on;
    var f = on ? "addEventListener" : "removeEventListener";
    document[f]("wheel", onWheel, { passive: false });
    document[f]("touchstart", onTouchStart, { passive: true, capture: true });
    document[f]("touchmove", onTouchMove, { passive: false, capture: true });
  }

  /* ---------- 8. Edit popup: ask before throwing away a change ---------- */
  var dirty = false, letClose = false, closeTarget = null, saving = false, saveT = 0;
  /* Teeinblue's edit popup moves the address to ?variant=<the edited line's variant> (on a product page that is a
     variant of ANOTHER product; the page itself stays right: same form, price, delivery date). Put the address back
     when the popup closes (×, Discard, Save), through History.prototype so FB Pixel counts no PageView (§59). */
  var editUrl = null;
  function restoreUrl() {
    if (editUrl && location.href !== editUrl) {
      try { History.prototype.replaceState.call(history, history.state, "", editUrl); } catch (err) {}
    }
    editUrl = null;
  }
  /* Ban-114 (anh 10:44 "đóng ngăn xong màn hình đơ"): sau khi bấm Save mà form thiếu ô rồi đóng bằng ×, popup của
     Teeinblue còn trong trang lúc 350 ms → editEnd() không chạy → editOpen kẹt true → chặn vuốt / lăn cả trang và
     html.ezcd-modal ở lại (đo: touchmove bị chặn sau khi đóng ngăn). Chờ tới khi popup thật sự đi (tối đa ~5 s). */
  function restoreSoon() {
    setTimeout(function () {
      restoreUrl();
      (function wait(n) {
        if (!document.querySelector(".tee-edit-popup")) { editEnd(); return; }
        if (n < 20) setTimeout(function () { wait(n + 1); }, 250);
      })(0);
    }, 350);
  }
  /* lưới an toàn: editOpen mà không còn popup thì thôi giữ trang */
  function editGone() {
    if (editOpen && !document.querySelector(".tee-edit-popup")) { editEnd(); return true; }
    return false;
  }
  function inEdit(t) { return t && t.closest && t.closest(".tee-edit-popup"); }
  function editLayer() {
    return document.querySelector(".tee-edit-popup") &&
      document.querySelector(".tee-edit-popup .vm--container, .ezp-ship:not(.is-leaving), .tee-edit-popup .ezp-dd.is-open, .ezp-ai.is-open");
  }
  function editChanged(e) {
    if (!e.isTrusted) return;
    var t = e.target;
    if (!inEdit(t) || !t.closest("#tee-artwork-form")) return;
    if (t.closest("#teeFormActions")) return;
    dirty = true;
    if (e.type === "change") setTimeout(function () { editDecor(24); }, 80);   /* Teeinblue có thể vẽ lại svg / nút */
  }
  function askDiscard(target) {
    closeTarget = target;
    ask("discard", "Discard your changes?", "Your design in the cart stays as it was.", "Keep editing", "Discard changes");
  }
  function askRemove(li) {
    rmLi = li;
    var t = li.querySelector(".ezcd-item__t"), im = li.querySelector(".ezcd-item__img img");
    var src = im && (im.currentSrc || im.src);
    if (src) ask("rm", "Remove this item?", "Your personalized design will be removed from the cart.", "Keep it", "Remove", src);
    else ask("rm", "Remove this item?", (t ? t.textContent + ". " : "") + "Your design for it will be removed from the cart.", "Keep it", "Remove");
  }
  function hideDiscard() {
    if (cfSheet) { var sh = cfSheet; cfSheet = null; try { sh.close(); } catch (err) {} return; }
    if (!confirmEl) return;
    confirmEl.classList.remove("is-open");
    confirmEl.setAttribute("aria-hidden", "true");
  }

  /* ---------- 9. one click + one keydown listener (window, capture) ---------- */
  function act(el, e) {
    var a = el.getAttribute("data-ezcd");
    if (a === "checkout") return;                       /* a real link: let it go */
    e.preventDefault();
    if (a === "close") { close(); return; }
    if (a === "pv") { openPv(el); return; }
    if (a === "anothercart") { open(el); load(); return; }   /* Ban-140 */
    if (a === "anotherfresh") { anotherFresh(el); return; }  /* Ban-141 */
    if (a === "pvclose") { closePv(); return; }
    if (a === "editcancel") { editCancel(); return; }
    if (a === "pvedit") {
      var src = pvBy && pvBy.closest(".ezcd-item"), eb = src && src.querySelector(".tee-edit-button");
      closePv();
      if (eb) eb.click();
      return;
    }
    if (a === "keep") { hideDiscard(); return; }
    if (a === "discard" && cfMode === "rm") {
      hideDiscard();
      if (rmLi && rmLi.isConnected) change(rmLi, 0);
      rmLi = null;
      return;
    }
    if (a === "discard") {
      hideDiscard();
      dirty = false;
      letClose = true;
      var t = closeTarget || document.querySelector(".tee-edit-popup .tee-dialog-close");
      if (t) t.click();
      letClose = false;
      restoreSoon();
      return;
    }
    var li = el.closest(".ezcd-item");
    if (!li) return;
    var q = parseInt(li.getAttribute("data-qty"), 10) || 1;
    if (a === "inc") change(li, q + 1);
    else if (a === "dec") { if (q <= 1) askRemove(li); else change(li, q - 1); }
    else if (a === "rm") askRemove(li);
  }
  window.addEventListener("click", function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* Ban-115 (anh 11:16: đóng popup Edit bằng × hay bấm ra ngoài thì "loạn" / chạm nhầm × của ngăn phía sau):
       ngón tay / chuột nhấn xuống trên popup Edit, popup đóng trước khi nhả → cú click rơi xuống thứ nằm dưới
       (× của ngăn, nền tối, trang). Click như vậy (≤ 700 ms sau khi nhấn trên popup, đích đã ngoài popup) bị bỏ. */
    if (Date.now() - popDown < 700 && !inEdit(t) && !t.closest(".ezcd-cf")) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    /* Teeinblue edit popup */
    if (t.closest(".tee-edit-button")) {
      dirty = false; editUrl = location.href;
      var pi = t.closest(".ezcd-item"), pim = pi && pi.querySelector(".ezcd-item__img img");
      editPrevImg = pim ? pim.getAttribute("src") : "";              /* Ban-119: ảnh cũ giữ chỗ tới khi ảnh mới có */
      /* Ban-122: ảnh thiết kế đã lưu (mockup Teeinblue dựng sẵn) làm ảnh chờ trong thẻ Live preview */
      var ci = pim, cr = !ci && t.closest(".cart-item");
      if (cr) ci = cr.querySelector("img.ez-cart-design");
      editPh = ci && /\/customizations\//.test(ci.getAttribute("src") || "") ? ci.getAttribute("src") : "";
      editStart(); return;
    }
    /* Ban-116: photo sheet "Remove photo" (outside the popup) changes the design */
    if (e.isTrusted && editOpen && t.closest('.ezp-pg-sheet [data-ezp-act="remove"]')) dirty = true;
    if (inEdit(t)) {
      /* Ban-116: "Adjust your photo" is a Teeinblue popup INSIDE the Edit popup — its ×, backdrop and Cancel close only
         itself (never the "Discard your changes?" question); its Save changes the design */
      var layer = t.closest(".vm--container");
      if (layer && !layer.classList.contains("tee-edit-popup")) {
        if (e.isTrusted && t.closest(".tee-dcontent-footer .tee-btn--primary")) dirty = true;
        return;
      }
      if (t.closest(".ezcd-ecancel")) { e.preventDefault(); e.stopImmediatePropagation(); editCancel(); return; }
      if (e.isTrusted && t.closest("#tee-artwork-form") && !t.closest("#teeFormActions") &&
          t.closest(".tee-clipart, label, .tee-radio, .tee-swatch, .tee-color, [role=radio], .tee-option, .tee-photo-clear") &&
          !t.closest(".tee-field--photo label")) dirty = true;   /* Ban-116: tapping a photo only opens its sheet */
      var closing = t.closest(".tee-dialog-close") || (t.classList.contains("vm--overlay") ? t : null);
      if (closing && dirty && !letClose) {
        e.preventDefault();
        e.stopImmediatePropagation();
        askDiscard(closing);
        return;
      }
      if (closing) restoreSoon();
      /* Ban-114: bấm Save KHÔNG coi là đang lưu — form thiếu ô thì Teeinblue dừng (không có sự kiện nào), Ban-113 để ngăn
         kẹt "Saving…" 15 s rồi báo "Design updated" sai, và quên là form đã sửa. Lưu thật bắt đầu ở before-cart-added. */
      return;
    }
    var d = t.closest("[data-ezcd]");
    if (d && (root && root.contains(d) || confirmEl && confirmEl.contains(d) || pvEl && pvEl.contains(d) || d.closest(".ezcd-ship, .ezcd-another"))) {
      if (d.getAttribute("data-ezcd") === "checkout") { closePv(); return; }
      act(d, e);
      return;
    }
    if (ON_CART) return;
    /* Ban-121 (anh 21/10 16:52): nút nổi "My cart" (ez-floating-buttons.js) và 2 lối "My cart" của nút gộp ĐT mở ngăn
       giỏ như icon giỏ trên header (trước: sang trang /cart). Nút gộp đang là nút mở menu (body.ez-fab-on) thì để nó tự xử lý. */
    /* Ban-123: + "View cart" trong khung "Added to your cart" của form Teeinblue */
    var icon = t.closest("#cart-icon-bubble, .ez-fab__item, .ez-fab__tag--cart, #tee-artwork-form .tee-success a") ||
      (document.body.classList.contains("ez-fab-on") ? null : t.closest(".ez-cartbtn"));
    if (icon) {
      e.preventDefault();
      e.stopImmediatePropagation();
      if (!icon.id) { var dim = document.querySelector(".ez-fab-dim"); if (dim && document.body.classList.contains("ez-fab-open")) dim.click(); }
      open(icon);
      load();
    }
  }, true);
  window.addEventListener("keydown", function (e) {
    if (e.key === "Tab" || e.key === "Enter" || e.key === " " || e.key === "Escape") kbd = true;
    /* Ban-115: Esc in the Edit popup = Cancel (asks first when the design was changed); ez-personalize no longer closes it */
    /* Ban-116: a window opened from the popup's form is on top (Adjust your photo, photo sheet, dropdown, AI) → its own Esc closes it */
    if (e.key === "Escape" && editLayer()) return;
    if (e.key === "Escape" && document.querySelector(".tee-edit-popup .vm--modal") && !cfOpen()) {
      e.preventDefault();
      editCancel();
      return;
    }
    if (cfOpen()) {
      if (e.key === "Escape") { e.preventDefault(); hideDiscard(); return; }
    }
    if (e.key === "Escape" && closePv()) { e.preventDefault(); return; }
    var t = e.target;
    if ((e.key === "Enter" || e.key === " ") && t && t.closest && t.closest("[data-ezcd]") && t.getAttribute("role") === "button") {
      act(t.closest("[data-ezcd]"), e);
      return;
    }
    if (!isOpen) return;
    if (document.querySelector(".tee-edit-popup .vm--modal")) return;   /* Teeinblue's popup is on top */
    if (e.key === "Escape") { e.preventDefault(); close(); return; }
    if (e.key === "Tab") {                                              /* keep focus inside the drawer */
      var f = panel.querySelectorAll('a[href], [role="button"][tabindex="0"], [tabindex="-1"].ezcd__panel, button');
      var list = Array.prototype.filter.call(f, function (x) { return x.offsetParent !== null || x === panel; });
      if (!list.length) return;
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }, true);
  document.addEventListener("input", editChanged, true);
  document.addEventListener("change", editChanged, true);

  /* Ban-112/114: Save trong popup Edit = Teeinblue THÊM dòng mới rồi XOÁ dòng cũ, rồi gọi handleCustomizationEditted.
     Ngăn đứng yên với "Saving your design…" và vẽ lại MỘT lần ở cuối (Ban-113 vẫn chạy nhánh Add to Cart: "Adding…",
     hiện dòng mới cạnh dòng cũ rồi mới xoá — anh 10:44). */
  function saveStart() {
    dirty = false;
    saving = true;
    if (root && isOpen) { addLabel("Saving your design\u2026"); root.classList.add("is-adding", "is-saving"); }
    clearTimeout(saveT);
    saveT = setTimeout(function () { if (saving) { saving = false; load({ edited: true }); } }, 15000);
  }

  /* ---------- 10. Teeinblue Add to Cart → drawer ---------- */
  if (!ON_CART) {
    document.addEventListener("teeinblue-event-campaign-loaded", noRedirect);
    document.addEventListener("teeinblue-event-before-cart-added", function () {
      noRedirect();
      if (editOpen || document.querySelector(".tee-edit-popup")) { saveStart(); return; }
      if (adding && isOpen) return;                    /* already open from before-customization-created */
      adding = true;
      open(document.activeElement);
      addLabel("Adding your design to the cart\u2026");
      root.classList.add("is-adding");
      clearTimeout(addTimer);
      addTimer = setTimeout(function () { if (adding) { adding = false; load(); } }, 15000);
    });
    document.addEventListener("teeinblue-event-after-cart-added", function () {
      if (saving) { preCart(); return; }               /* Save in the edit popup: wait for handleCustomizationEditted; ảnh mới tải trước */
      adding = false;
      clearTimeout(addTimer);
      open();
      load({ added: true });
      anotherAdded();                                  /* Ban-143 */
    });
    document.addEventListener("teeinblue-event-error", function () {
      if (saving) { saving = false; clearTimeout(saveT); if (root) root.classList.remove("is-adding", "is-saving"); }
      if (!adding) return;
      adding = false;
      clearTimeout(addTimer);
      close();
    });
    /* something else changed the cart while the drawer is open (e.g. the gift box that ez-offer.js adds after
       Teeinblue's add): redraw once things settle */
    var modT = 0;
    document.addEventListener("shopify-event-cart-modified", function () {
      if (!isOpen || busy || adding || saving) return;
      clearTimeout(modT);
      modT = setTimeout(function () { if (!busy) load(); }, 350);
    });
  }

  /* Ban-112 (anh: opening did not feel quick): the drawer content is fetched once at idle when the cart has something,
     so a tap on the cart icon shows it at once (then refreshes); hovering the icon fetches it too. */
  var loadedOnce = false;
  /* Ban-119: trang được phục vụ với số giỏ "0" rồi một script khác điền số thật từ cart.js (~1,5 s, đo 21/10) → warm()
     lúc rảnh thấy 0 và không bao giờ tải trước (mở giỏ phải chờ cả nội dung lẫn ảnh). Giờ: còn 0 thì theo dõi ô số
     tới 10 s, có số > 0 là tải trước ngay. */
  var warmWatch = null;
  function warm() {
    if (loadedOnce || busy || ON_CART) return;
    var b = document.getElementById("header-cart-count-bubble");
    if (b && (parseInt(b.textContent, 10) || 0) > 0) {
      loadedOnce = true;
      if (warmWatch) { warmWatch.disconnect(); warmWatch = null; }
      load();
    } else if (b && !warmWatch && window.MutationObserver) {
      warmWatch = new MutationObserver(function () { warm(); });
      warmWatch.observe(b, { childList: true, characterData: true, subtree: true });
      setTimeout(function () { if (warmWatch) { warmWatch.disconnect(); warmWatch = null; } }, 10000);
    }
  }
  var atcTap = 0;
  /* Ban-115: Teeinblue (vue-js-modal) closes its popup on Esc *keyup* — without our "Discard your changes?" (anh 11:16:
     popup đóng mà hộp hỏi vẫn hiện). The Edit popup's Esc is handled on keydown above (= Cancel). */
  window.addEventListener("keyup", function (e) {
    if (e.key !== "Escape" || !document.querySelector(".tee-edit-popup .vm--modal")) return;
    e.stopImmediatePropagation();
    /* Ban-116: "Adjust your photo" open on top → Esc closes only that one (vue-js-modal would close both) */
    var ip = document.querySelector(".tee-edit-popup .vm--container .tee-dialog-close");
    if (ip) ip.click();
  }, true);
  var kbd = false, popDown = 0;
  window.addEventListener("pointerdown", function (e) {
    var t = e.target;
    kbd = false;
    popDown = t && t.closest && t.closest(".tee-edit-popup") ? Date.now() : 0;
    if (t && t.closest && t.closest(".tee-btn--atc") && !t.closest(".tee-edit-popup, .tee-dialog")) atcTap = Date.now();
    if (t && t.closest && t.closest("#cart-icon-bubble, .ez-cartbtn, .ez-fab__item, .ez-fab__tag--cart")) warm();
  }, true);
  if (!ON_CART) {
    /* Teeinblue checks the form first, then makes the design (0.85 s on 21/10), then adds: open as soon as the
       design starts, right after a tap on Add to Cart (not for Preview, which also makes a design) */
    document.addEventListener("teeinblue-event-before-customization-created", function () {
      if (Date.now() - atcTap > 4000 || isOpen) return;
      noRedirect();
      adding = true;
      open(document.activeElement);
      addLabel("Adding your design to the cart\u2026");
      root.classList.add("is-adding");
      clearTimeout(addTimer);
      addTimer = setTimeout(function () { if (adding) { adding = false; load(); } }, 15000);
    });
  }
  /* ---------- 11. Ban-140 (anh 23/10): "+ Add another" ----------
     Dòng giỏ có link "+ Add another" → trang SP ?variant=…&customization-id=…&ez_another=1. customization-id là cách của
     Teeinblue (collectCustomization → setImmediateLocalCustomization): form đầy đủ nạp đúng thiết kế đã lưu (đo TEST 12:
     Anna/Ben), khách đổi tên / biến thể / số lượng, Add to Cart tạo dòng MỚI; dòng cũ không bị đụng (Save trong popup Edit
     = actionAddToCart + removeLineItemByCustomizationId, ở đây không có bước xoá). Khi có customization-id, Teeinblue không
     trộn bộ nhớ sync_between_templates (ME() trong app-v1) → không lẫn tên của SP khác.
     Ở đây: dòng "Making another one" ngay trên form + cuộn tới form một lần (chỉ khi khách chưa tự cuộn). */
  var ANOTHER = !ON_CART && /[?&]ez_another=1(&|$)/.test(location.search) && /[?&]customization-id=[^&]/.test(location.search);
  var anotherEl = null;
  var ANOTHER_T = "Making another one",
      ANOTHER_D = "Make your changes below, then Add to cart. Your first one stays in the cart.";   /* Ban-143: mọi loại SP (tên, ảnh, chữ) */
  var IC_PLUS = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>',
      IC_OK = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  function pageTeeForm() {
    var all = document.querySelectorAll("#tee-artwork-form");
    for (var i = 0; i < all.length; i++) if (!all[i].closest(".tee-dialog, .ezcd")) return all[i];
    return null;
  }
  /* Ban-143: chờ form không giới hạn 15 s nữa (mạng ĐT chậm vẫn có dòng). Theo dõi DOM (MutationObserver) + kiểm tra
     mỗi 1 s, dừng ở 60 s. Dòng hiện muộn khi khách đã tự cuộn thì không cuộn (anotherScroll: scrollY > 40). */
  function another() {
    if (!ANOTHER || anotherEl) return;
    var mo = null, iv = 0, t0 = Date.now(), pend = 0;
    function stop() { if (mo) { mo.disconnect(); mo = null; } clearInterval(iv); clearTimeout(pend); }
    function kick() { if (!pend) pend = setTimeout(function () { pend = 0; wait(); }, 120); }
    if (window.MutationObserver) { mo = new MutationObserver(kick); mo.observe(document.documentElement, { childList: true, subtree: true }); }
    iv = setInterval(wait, 1000);
    wait();
    function wait() {
      if (anotherEl) { stop(); return; }
      /* Ban-142 (anh 23/10 19:03 chọn C): dòng nằm NGAY TRÊN khung "Personalized" (#teeFormInputs) — đúng chỗ dòng
         "Welcome back" của ez-personalize (Ban-139), cùng kiểu, gọn 2 dòng. Đo 375 (trước, trên giá): dòng 264 → ô số người
         741 / ô tên 1090; nay → ô số người ~420 / ô tên ~770. Pack và giá ở trên (thẻ Live preview nổi che khi mới vào).
         Không có #teeFormInputs (Teeinblue đổi) → chỗ cũ: trước form của theme. */
      var f = pageTeeForm(), fi = f && f.querySelector("#teeFormInputs"), host = fi || (f && (f.closest("form") || f));
      if (!host || !host.parentNode || !f.querySelector("input, textarea, select")) {
        if (Date.now() - t0 > 60000) stop();          /* Teeinblue dựng form ~1–3 s */
        return;
      }
      stop();
      css();
      anotherEl = document.createElement("div");
      anotherEl.className = "ezcd-another";
      anotherEl.setAttribute("role", "status");
      if (!cssOk) anotherEl.style.display = "none";
      anotherEl.innerHTML =
        '<span class="ezcd-another__ic" aria-hidden="true">' + IC_PLUS + '</span>' +
        '<div class="ezcd-another__b">' +
          '<b class="ezcd-another__t">' + ANOTHER_T + '</b>' +
          '<p class="ezcd-another__d"><span class="ezcd-another__dt">' + ANOTHER_D + '</span></p>' +
          /* anh 19:09: các nút đứng cùng một hàng */
          '<div class="ezcd-another__ks">' +
            (canFresh() ? '<span class="ezcd-another__k" role="button" tabindex="0" data-ezcd="anotherfresh" data-k="Start fresh">Start fresh</span>' : '') +
            '<span class="ezcd-another__k" role="button" tabindex="0" data-ezcd="anothercart">View cart</span>' +
          '</div>' +
        '</div>';
      host.parentNode.insertBefore(anotherEl, host);
      setTimeout(anotherScroll, cssOk ? 80 : 600);
    }
  }
  /* Ban-143 (anh 23/10 20:55): Add to cart xong ở trang này → dòng đổi sang "Added to your cart ✓" + "Make another"
     (= Start fresh: form trống, có Undo) + "View cart" → mời khách làm món thứ 3. Bản sao lưu Start fresh cũ bỏ đi
     (thiết kế đó đã nằm trong giỏ); Undo lúc này = thiết kế vừa thêm quay về. Thêm nhiều lần: "2 added to your cart". */
  var anotherN = 0;
  function anotherAdded() {
    if (!anotherEl) return;
    anotherN++;
    anotherBk = null;
    anotherEl.classList.add("is-added");
    var ic = anotherEl.querySelector(".ezcd-another__ic"), tt = anotherEl.querySelector(".ezcd-another__t"),
        d = anotherEl.querySelector(".ezcd-another__dt"), k = anotherEl.querySelector('[data-ezcd="anotherfresh"]');
    if (ic) ic.innerHTML = IC_OK;
    if (tt) tt.textContent = anotherN > 1 ? anotherN + " added to your cart" : "Added to your cart";
    if (d) d.textContent = k ? "Want one for someone else too? Make another starts a new design." : "Want one for someone else too? Change the design below and Add to cart again.";
    if (k) { k.setAttribute("data-k", "Make another"); k.textContent = "Make another"; }
  }
  /* Ban-141 (anh 23/10 14:35: "thêm chức năng refresh để khách làm mới lựa chọn nhanh"): "Start fresh" trong dòng
     "Making another one" = form trống để làm thiết kế khác hẳn; bấm lại "Undo" = thiết kế đã nạp quay về.
     Cùng cách Ban-139 (Welcome back): Teeinblue resetCustomization / refillCustomization + bản lưu nháp
     localStorage "teeinblue-customizations"; bộ nhớ sync_between_templates (theo nhãn ô) cũng làm trống, nếu không
     chọn lại số người là tên cũ quay về (đo TEST 13: reset → ["",""], chọn 3 người → ["","",""], Undo → Anna/Ben).
     Biến thể (Pack) giữ nguyên. Hàm tìm bộ nhớ chép từ ez-personalize.js (syncMemories, Ban-139) để 2 file độc lập. */
  var anotherBk = null;
  function anotherPid() {
    var m = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    return m && m.product && m.product.id ? m.product.id : null;
  }
  function canFresh() {
    var T = window.teeinblue;
    return !!(anotherPid() && T && typeof T.resetCustomization === "function" && typeof T.refillCustomization === "function");
  }
  function tibMemories(pid) {
    var found = [], seen = [];
    function vnode(v, d) {
      if (!v || typeof v !== "object" || d > 400) return;
      if (v.component) comp(v.component, d + 1);
      if (Array.isArray(v.children)) v.children.forEach(function (c) { vnode(c, d + 1); });
      if (v.suspense && v.suspense.activeBranch) vnode(v.suspense.activeBranch, d + 1);
    }
    function comp(c, d) {
      if (!c || seen.indexOf(c) !== -1) return;
      seen.push(c);
      try {
        var px = c.proxy, m = px && px.useGlobalCustomizationData;
        if (m && m.globalCustomizationData && String(px.productId) === String(pid)) found.push(m);
      } catch (err) {}
      vnode(c.subTree, d + 1);
    }
    try {
      Array.prototype.forEach.call(document.querySelectorAll("div"), function (el) {
        if (el._vnode && !el.closest(".tee-edit-customization, .tee-edit-popup")) vnode(el._vnode, 0);
      });
    } catch (err) {}
    return found;
  }
  function anotherFresh(el) {
    var T = window.teeinblue, pid = anotherPid(), d = anotherEl && anotherEl.querySelector(".ezcd-another__dt"),
        tt = anotherEl && anotherEl.querySelector(".ezcd-another__t");
    if (!T || !pid) return;
    if (!anotherBk) {                                /* Start fresh */
      var ls = null;
      try { ls = localStorage.getItem("teeinblue-customizations"); } catch (err) {}
      var mems = tibMemories(pid);
      anotherBk = { ls: ls, mems: mems, old: mems.map(function (m) { var o = m.globalCustomizationData; m.globalCustomizationData = {}; return o; }) };
      try { T.resetCustomization(pid); } catch (err) {}
      el.textContent = "Undo";
      if (anotherEl) { anotherEl.classList.remove("is-added"); var ic = anotherEl.querySelector(".ezcd-another__ic"); if (ic) ic.innerHTML = IC_PLUS; }
      if (tt) tt.textContent = "Started a new design";
      if (d) d.textContent = "Fill in everything below, then Add to cart. Your first one stays in the cart.";
      setTimeout(anotherUncover, 500);
      setTimeout(anotherUncover, 1300);
    } else {                                         /* Undo */
      var b = anotherBk;
      anotherBk = null;
      b.mems.forEach(function (m, i) { m.globalCustomizationData = b.old[i]; });
      try { if (b.ls) localStorage.setItem("teeinblue-customizations", b.ls); T.refillCustomization(pid); } catch (err) {}
      el.textContent = el.getAttribute("data-k") || "Start fresh";
      if (tt) tt.textContent = ANOTHER_T;
      if (d) d.textContent = ANOTHER_D;
    }
  }
  /* Form đổi → thẻ "Live preview" nổi (ĐT/tablet, fixed top 8, cao 244 ở 375) hiện ra và che đúng dòng này
     (đo TEST 13: dòng 73–205, thẻ 8–252 → chạm "Undo" rơi vào ảnh). Sau Start fresh: đẩy dòng xuống dưới thẻ. */
  function anotherUncover() {
    if (!anotherEl || !anotherBk) return;
    var cards = document.querySelectorAll(".tee-gallery-content"), bottom = 0;
    for (var i = 0; i < cards.length; i++) {
      var cs = getComputedStyle(cards[i]);
      if (cs.position !== "fixed" || cs.visibility === "hidden" || cs.display === "none" || +cs.opacity < 0.1) continue;
      var r = cards[i].getBoundingClientRect();
      if (r.height > 0 && r.top < 120) bottom = Math.max(bottom, r.bottom);
    }
    if (!bottom) return;
    var top = anotherEl.getBoundingClientRect().top;
    if (top >= bottom + 4 || top < -400) return;
    var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    window.scrollTo({ top: Math.max(0, window.scrollY - (bottom + 8 - top)), behavior: calm ? "auto" : "smooth" });
  }
  /* Ban-141: đáy thẻ "Live preview" nổi (<990) khi nó hiện — cùng công thức sizeCard() của tee-sticky-gallery.js
     (ĐT: k = .5–.62 sao cho thẻ ≈ 30% màn; tablet ≥600: k = .3–.5, ≈ 27%; thẻ = slider × k + 16, top 8).
     Cuộn để dòng "Making another one" nằm ngay dưới chỗ thẻ sẽ hiện → thẻ không che "Start fresh / Undo"
     (375×812: thẻ 8–252 đo thật, công thức 252). Không có khung ảnh → 0 (chỉ tính header như Ban-140). */
  function cardGuess() {
    if (window.innerWidth >= 990) return 0;
    /* slider Teeinblue có khi chưa vẽ lúc này (trang mở bằng customization-id: chỉ có ảnh Shopify tới khi khách chạm form)
       → dùng bề ngang khung ảnh (mockup vuông: slider 375 = khung 375 ở ĐT 375) */
    var mw = document.querySelector(".product__media-wrapper"), sl = mw && mw.querySelector(".tee-slider");
    var h = (sl && sl.offsetHeight) || (mw ? mw.offsetWidth : 0);
    if (!h) return 0;
    var vh = window.innerHeight, k = window.innerWidth >= 600
      ? Math.max(0.3, Math.min(0.5, (vh * 0.27 - 16) / h))
      : Math.max(0.5, Math.min(0.62, (vh * 0.30 - 16) / h));
    return 8 + Math.round(h * k) + 16;
  }
  function anotherScroll(tries) {
    if (!anotherEl || window.scrollY > 40) return;      /* khách đã tự cuộn: để yên */
    /* gallery Teeinblue thường vẽ sau form (đo: lúc dòng này hiện, slider cao 0) → chờ tối đa 3 s để biết chỗ thẻ */
    if (window.innerWidth < 990 && !cardGuess() && (tries || 0) < 12) { setTimeout(function () { anotherScroll((tries || 0) + 1); }, 250); return; }
    var hd = document.querySelector("sticky-header, .section-header"), hb = hd ? Math.max(0, hd.getBoundingClientRect().bottom) : 0;
    var y = anotherEl.getBoundingClientRect().top + window.scrollY - Math.max(hb, cardGuess()) - 12;
    var calm = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (y > 0) window.scrollTo({ top: y, behavior: calm ? "auto" : "smooth" });
  }

  function boot() {
    another();
    saveTib();
    noRedirect();
    hooks();
    var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 1200); };
    if (!ON_CART) idle(function () { shell(); warm(); }, { timeout: 3000 });
    else {                             /* /cart: only the edit popup styles + discard question */
      css();
      if (document.querySelector(".tee-edit-customization")) ezp(false);   /* Ban-116 */
      setTimeout(function () { if (tibLoaded()) tibScan(); }, 800);   /* buttons after the show_edit_button switch */
      setTimeout(function () { tibPrefetch(document.querySelector("cart-items") || document.body); }, 1500);   /* Ban-122 */
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();

  window.ezCartDrawer = { open: function () { open(); return load(); }, close: close, reload: load };
})();
